import React, { useEffect, useState } from 'react'
import { FormGrid, FormGroup, Input, Label, Select, SubTitle } from '../../../style'
import axios from 'axios'
import { ManageOrderStateByProduct } from '../../..'

const OfferedItem:React.FC<ManageOrderStateByProduct> = ({ order, setOrder, index }) => {
  const [ bitolas, setBitolas ] = useState<{codeId:number, description:string}[]>([])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STEEL_ORDERS_BASE_URL}/select-in-order/bitolas`)
      .then(response => {
        if(response.data) setBitolas(response.data)
      }
      )
      .catch(error =>
        console.error(error)
      )
  }, [])

    const onChangeSetValue = (e: React.ChangeEvent<HTMLInputElement>) => {
      setOrder((prev) => ({
        ...prev,
        items:prev.items.map((item, i) => i === index ? {
          ...prev.items[index],
          offeredProduct: {
            ...prev.items[index].offeredProduct,
            [e.target.name]: e.target.value
          }
        } : item)
      }))
      }
  
  return(
    <>
      <SubTitle style={{ marginTop: '3rem' }}>Ofertado:</SubTitle>
        <FormGrid style={{ marginTop: '16px' }}>
          <FormGroup>
            <Label>Produto (estoque)</Label>
            <Select>
              <option>Selecione</option>
              {bitolas.map(bitola => (
                <option key={bitola.codeId}>{bitola.description}</option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>NCM</Label>
            <Input />
          </FormGroup>
          <FormGroup>
            <Label>Formato</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Diâmetro</Label>
            <Input
              autoComplete='off'
              name='diameter' 
              value={order.items[index].offeredProduct.diameter} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
          <FormGroup>
            <Label>Espessura</Label>
            <Input
              autoComplete='off'
              name='thickness' 
              value={order.items[index].offeredProduct.thickness} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
        </FormGrid>
        <FormGrid>
          <FormGroup>
            <Label>Comprimento</Label>
            <Input
              autoComplete='off'
              name='length' 
              value={order.items[index].offeredProduct.length} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
          <FormGroup>
            <Label>Acabamento</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Peso</Label>
            <Input
              autoComplete='off'
              name='weigth'
              value={order.items[index].offeredProduct.weigth} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
          <FormGroup>
            <Label>Especificações</Label>
            <Input
              autoComplete='off'
              name='specs' 
              value={order.items[index].offeredProduct.specs} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
          <FormGroup>
            <Label>Quantidade</Label>
            <Input
              autoComplete='off'
              name='quantity' 
              value={order.items[index].offeredProduct.quantity} 
              onChange={onChangeSetValue}
              type='number'
              min='0'
            />
          </FormGroup>
        </FormGrid>
    </>
  )
}

export default OfferedItem